import React from 'react'
import { MdClose } from 'react-icons/md'
import './new-teacher-card-modal.css'

const NewTeacherCardModal = ({open, onClose, onSubmit, isSubmitting}) => {
    const [teacherName, setTeacherName] = React.useState('')

    React.useEffect(() => {
        if (!open) {
            setTeacherName('')
        }
    }, [open])

    if (!open) {
        return null
    }

    const submit = () => {
        const trimmedTeacherName = teacherName.trim()
        if (!trimmedTeacherName || isSubmitting) return
        onSubmit(trimmedTeacherName)
    }

    return (
        <div className='new-teacher-card-modal__backdrop' id='new-teacher-card-modal__backdrop' onClick={(e) => e.target.id === 'new-teacher-card-modal__backdrop' && !isSubmitting && onClose()}>
            <div className='new-teacher-card-modal'>
                <div className='new-teacher-card-modal__header'>
                    <div className='new-teacher-card-modal__title'>New Teacher Card</div>
                    <MdClose color='#94A3B8' size={22} cursor={isSubmitting ? 'default' : 'pointer'} onClick={() => !isSubmitting && onClose()} />
                </div>
                <div className='new-teacher-card-modal__body'>
                    <label className='new-teacher-card-modal__label'>Teacher Name</label>
                    <input
                        autoFocus
                        className='new-teacher-card-modal__input'
                        placeholder='Jane Smith'
                        value={teacherName}
                        onChange={(e) => setTeacherName(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && submit()}
                    />
                </div>
                <div className='new-teacher-card-modal__actions'>
                    <div className='new-teacher-card-modal__button' onClick={() => !isSubmitting && onClose()}>Cancel</div>
                    <div className='new-teacher-card-modal__button new-teacher-card-modal__button--primary' onClick={submit}>
                        {isSubmitting ? 'Creating...' : 'Create Card'}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewTeacherCardModal
